import ToastHighLighter from '@/lib/ToastHighLighter';

export const ToolsAndServiceTemplateCode = () => {
  const language = 'html';
  const codeString = `
  // Tools & Services Basic Template
  ...
  <!-- START NAVIGATION -->
  <nav
    className="navbar navbar-expand-lg navbar-light"
    role="navigation"
  >
    <a className="navbar-brand">
      <img
        src=""
        alt="FHNW - Fachhochschule Nordwestschweiz"
        height=""
        width=""
      />
    </a>      

    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="navbarId"
      aria-controls=""
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon"></span> Menü
    </button>

    <!-- MAIN NAVIGATION -->
    <div className="collapse navbar-collapse" id="navbarId">
      <ul className="navbar-nav mr-auto mt-2 mt-md-0">
        <li className="nav-item">
          <a className="nav-link" aria-current="page">
            Home
          </a>
        </li>
        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            id="navbarCorporate"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Single Dropdown
          </a>
    
          <ul className="dropdown-menu" aria-labelledby="navbarCorporate">
            <li>
              <a className="dropdown-item" title="Webdienste">
                Subitem I
              </a>
            </li>
            <li>
              <a className="dropdown-item" title="Tools und Services">
                Subitem II
              </a>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
          </ul>
        </li>
        <li className="nav-item dropdown has-megamenu">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            data-bs-toggle="dropdown"
          >
            Megamenu
          </a>
          <div className="dropdown-menu megamenu" role="menu">
            <MegaMenuDemo title="Metatitle" />
          </div>
        </li>
        <li>
          <a className="nav-link ">Topic II</a>
        </li>
      </ul>
    </div>

    <!-- LANGUAGE SWITCHER -->
    <div className="collapse navbar-collapse d-flex justify-content-end d-none">
      <div className="language-menu border-primary border-end px-4">
        <ul className="navbar-nav mr-auto mt-2 mt-md-0 gap-2">
          <li className="nav-item">              
            <a
              href=""
              className="btn btn-outline-secondary btn-sm bg-primary text-white px-2"
              aria-current="page"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title="Demonstration purposes only"
            >
              DE
            </a>
          </li>
          <li className="nav-item">              
            <a
              href=""
              className="btn btn-outline-secondary bg-transparent btn-sm px-2"
              aria-current="page"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title="Demonstration purposes only"
            >
              EN
            </a>
          </li>
        </ul>
      </div>

      <!-- USER DROPDOWN -->
      <ul className="navbar-nav mr-auto mt-2 mt-md-0 px-3">
        <li className="nav-item dropdown">
          <a href="#" className="nav-link dropdown-toggle d-flex align-items-center" id="navbarDropdown3" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <img src="" className="rounded-circle" height="22" alt="Avatar" loading="lazy"/>
          </a>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown3">
            <li>            
              <a href="" target="_blank" className="dropdown-item" title="">My Profile</a>
            </li>
            <li>
              <a href="" target="_blank" className="dropdown-item" title="Settings">Settings</a>
            </li>
            <li>                
              <a href="" target="_blank" className="dropdown-item" title="Logout">Logout</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
  <!-- CONTENT -->
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Title</h1>
      </div>
    </div>
  </div>

  
  <!-- WEBDIENST FOOTER -->
  <footer id="footer">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4">
          <h4>Kontakt</h4>
          <p>
            Fachhochschule Nordwestschweiz FHNW
            <br />
            Corporate IT
            <br />
            Multimedia &amp; Communications
            <br />
            Bahnhofstrasse 6<br />
            5210 Windisch
          </p>
          <p>
            E-Mail: <a href="mailto:webmaster@fhnw.ch">webmaster@fhnw.ch</a>
          </p>

          <SocialMediaIcons />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 order-first order-md-0">
          <h4>Über diese Website</h4>
          <p>
            Der Web-Styleguide der FHNW bildet das verbindliche
            Standard-Design der FHNW-Webdienste ab und erlaubt, dieses auf
            Basis eines Bootstrap5-Frameworks in der Webentwicklung zu
            nutzen.
          </p>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4">
          <h4>Quicklinks</h4>
          <p>
            <a href="https://webteam.pages.fhnw.ch/fhnw-styleguide-v4/cd/webdienste/">
              Webdienste
            </a>
            <br />
            <a href="/cd/tools-und-services/">Tools und Services</a>
            <br />
            <a href="https://webteam.pages.fhnw.ch/fhnw-styleguide-v4/maintenance/">
              Maintenance Template
            </a>
            <br />
            <a href="#">Quicklinks</a>
          </p>
        </div>
      </div>
    </div>
    <div class="container tools__footer">
      <div class="row">
        <div class="d-flex justify-content-center">
          <p>
            <a href="https://www.fhnw.ch" target="_blank">
              www.fhnw.ch
            </a>
            <span class="d-inline-block mx-1 mx-md-2">|</span>
            <a href="#">Impressum</a>
            <span class="d-inline-block mx-1 mx-md-2">|</span>
            <a href="#">Datenschutz</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
  ...
`;

  return (
    <>
      <ToastHighLighter
        name={'webdienstplain'}
        codeString={codeString}
        language={language}
        show={false}
      />
    </>
  );
};
